import React, { memo, useEffect, useMemo, useRef, useState } from "react";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DefaultView from "../components/DefaultView";
import EmailLeftbar from "../components/EmailLeftbar";
import EmailListItem from "../components/EmailListItem";
import {
  actionGetReceivedMessages,
  actionMarkAddImportant,
  actionMarkRemoveImportant,
  actionMarkReadMessages,
  actionMarkUnreadMessages,
  actionMarkAddStarred,
  actionMarkRemoveStarred,
  actionMarkTrashMessage,
} from "../store/actions/inboxAction";
import EmptyResult from "../components/EmptyResult";
import Swal from "sweetalert2";
import { actionGetFaxQueuesCount, actionGetUnReadMessagesCount } from "../store/actions/sentFaxesAction";


const Inbox = memo(
  ({
    actionGetReceivedMessages,
    getReceivedMessagesLoader,
    receivedMessages,
    receivedMessagesCount,
    actionMarkAddImportant,
    actionMarkRemoveImportant,
    addImportantLoader,
    removeImportantLoader,
    markReadLoader,
    markUnreadLoader,
    markTrashLoader,
    actionMarkReadMessages,
    actionMarkUnreadMessages,
    actionMarkAddStarred,
    actionMarkRemoveStarred,
    actionMarkTrashMessage,
    actionGetUnReadMessagesCount
  }) => {
    const [searchText, setSearchText] = useState("");
    const [type, setType] = useState("");
    const [listType, setListType] = useState(false);
    const [filteredEmailListItems, setFilteredEmailListItems] = useState([]);
    const navigate = useNavigate();

    const offset = useRef(0);
    const [itemsPerPage] = useState(20);

    const { pathname } = useLocation();

    useEffect(() => {
      // Retrieve offset from local storage
      const storedOffset = localStorage.getItem("inboxOffset");
      offset.current = storedOffset ? parseInt(storedOffset, 10) : 0;

      switch (pathname) {
        case "/inbox-new":
        case "/inbox":
          actionGetReceivedMessages(offset.current, "NO");
          setListType("NO");
          break;

        case "/inbox/important":
          actionGetReceivedMessages(offset.current, "YES");
          setListType("YES");
          break;

        default:
          break;
      }
    }, [pathname, actionGetReceivedMessages]);

    // Save offset to local storage whenever it changes
    useEffect(() => {
      localStorage.setItem("inboxOffset", offset.current.toString());
    }, [offset.current]);

    const handleSearch = () => {
      // Implement your search logic here using 'searchText' state
      actionGetReceivedMessages(0, listType, searchText);
      offset.current = 0;
    };

    useEffect(() => {
      const filtered =
        receivedMessages &&
        receivedMessages.filter((record) => {
          if (pathname === "/inbox" || pathname === "/inbox/important") {
            return record.msg.msg_senderName
              .toLowerCase()
              .includes(searchText.toLowerCase());
          }
          return true;
        });

      setFilteredEmailListItems(filtered);
    }, [searchText, pathname, receivedMessages]);

    useMemo(() => {
      setFilteredEmailListItems(
        receivedMessages.map((msg) => ({ ...msg, isSelected: false }))
      );
      if (receivedMessages.length < 1) {
        // setOffset(offset);
      }
    }, [receivedMessages]);

    const handleRefresh = () => {
      offset.current = 0;
      setSearchText("");
      actionGetReceivedMessages(offset.current, listType);
      actionGetUnReadMessagesCount();
    };

    const handleNextClick = () => {
      offset.current += 1;
      actionGetReceivedMessages(
        offset.current,
        listType,
        searchText ? searchText : ""
      );
    };

    const handleBackClick = () => {
      const newOffset = offset.current - 1;

      actionGetReceivedMessages(
        newOffset,
        listType,
        searchText ? searchText : ""
      );
      offset.current = newOffset;
    };

    const handleSelectThisPage = (importantType) => {
      const pageData = filteredEmailListItems.map((m) => ({
        ...m,
        isSelected: true,
      }));
      setFilteredEmailListItems(pageData);
      importantType && importantType == "selectAll"
        ? setType("selectAll")
        : importantType == "selectThisPage"
          ? setType("selectThisPage")
          : setType("");
    };

    const handleDeSelectAll = () => {
      setType("");
      setFilteredEmailListItems(
        filteredEmailListItems.map((m) => ({
          ...m,
          isSelected: false,
        }))
      );
    };
    const handleSelectAll = () => {
      handleSelectThisPage("selectAll");
      // TODO: logic for server data change
    };

    const handleSelectMessage = (index) => {
      setType("");

      const newFilteredEmailListItems = filteredEmailListItems.map((m, i) => {
        if (index === i) {
          return { ...m, isSelected: !m.isSelected };
        } else {
          return m;
        }
      });
      setFilteredEmailListItems(newFilteredEmailListItems);
    };
    const handleStarred = (index, type) => {
      const selectedMsg = filteredEmailListItems[index];

      if (selectedMsg) {
        const recvd_msg_ID = selectedMsg.msg.recvd_msg_ID;

        type == "starAdd"
          ? actionMarkAddStarred({ recvd_msg_ID })
          : actionMarkRemoveStarred({ recvd_msg_ID });
      }
    };

    const handleMarkReadSelected = async () => {
      const selectedIds = filteredEmailListItems
        .filter((m) => m.isSelected)
        .map((m) => m.msg.recvd_msg_ID);

      try {
        if (type && type == "selectAll") {
          await actionMarkReadMessages({
            recvd_msg_ID: [0],
            select_all: "YES",
          });
        } else {
          await actionMarkReadMessages({
            recvd_msg_ID: selectedIds,
            select_all: "NO",
          });
        }

        // Call after the mark operation completes
        actionGetUnReadMessagesCount();
      } catch (error) {
        console.error("Error marking messages as read:", error);
      }
    };

    const handleMarkUnReadSelected = async () => {
      const selectedIds = filteredEmailListItems
        .filter((m) => m.isSelected)
        .map((m) => m.msg.recvd_msg_ID);

      try {
        if (type && type == "selectAll") {
          await actionMarkUnreadMessages({
            recvd_msg_ID: [0],
            select_all: "YES",
          });
        } else {
          await actionMarkUnreadMessages({
            recvd_msg_ID: selectedIds,
            select_all: "NO",
          });
        }

        // Call after the mark operation completes
        actionGetUnReadMessagesCount();
      } catch (error) {
        console.error("Error marking messages as unread:", error);
      }
    };

    const handleMarkAddImportant = () => {
      const selectedIds = filteredEmailListItems
        .filter((m) => m.isSelected)
        .map((m) => m.msg.recvd_msg_ID);

      type && type == "selectAll"
        ? actionMarkAddImportant(
          {
            recvd_msg_ID: [0],
            select_all: "YES",
          },
          filteredEmailListItems
        )
        : actionMarkAddImportant(
          {
            recvd_msg_ID: selectedIds,
            select_all: "NO",
          },
          filteredEmailListItems
        );
    };

    const handleMarkRemoveImportant = () => {
      const selectedIds = filteredEmailListItems
        .filter((m) => m.isSelected)
        .map((m) => m.msg.recvd_msg_ID);

      const getMessageParams = {
        offset: offset.current,
        listType,
        searchText,
      };

      type && type == "selectAll"
        ? actionMarkRemoveImportant(
          {
            recvd_msg_ID: [0],
            select_all: "YES",
          },
          filteredEmailListItems,
          getMessageParams
        )
        : actionMarkRemoveImportant(
          {
            recvd_msg_ID: selectedIds,
            select_all: "NO",
          },
          filteredEmailListItems,
          getMessageParams
        );
    };
    const handleMarkTrash = () => {
      const selectedIds = filteredEmailListItems
        .filter((m) => m.isSelected)
        .map((m) => m.msg.recvd_msg_ID);

      const getMessageParams = {
        offset: offset.current,
        listType,
        searchText,
      };

      // Confirmation before delete
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to move the selected message(s) to trash?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, move to trash",
      }).then((result) => {
        if (result.isConfirmed) {
          actionMarkTrashMessage(
            {
              recvd_msg_ID: selectedIds,
            },
            getMessageParams
          );
        }
      });
    };

    const showingFrom = offset.current * itemsPerPage + 1;
    const showingTo = Math.min(
      (offset.current + 1) * itemsPerPage,
      receivedMessagesCount
    );

    const BackAndNextButtonsGroup = () => (
      <div className="btn-group float-end">
        <button
          type="button"
          className="btn btn-sm btn-success waves-effect"
          onClick={handleBackClick}
          disabled={offset.current === 0}
        >
          <i className="fa fa-chevron-left" />
        </button>
        <button
          type="button"
          className="btn btn-sm btn-success waves-effect"
          onClick={handleNextClick}
          disabled={
            (offset.current + 1) * itemsPerPage >= receivedMessagesCount ||
            !receivedMessagesCount ||
            !filteredEmailListItems.length
          }
        >
          <i className="fa fa-chevron-right" />
        </button>
      </div>
    );

    // Initialize Bootstrap tooltips with comprehensive cleanup
    useEffect(() => {
      // Function to safely dispose tooltips
      const disposeTooltips = () => {
        const existingTooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        existingTooltips.forEach(element => {
          try {
            const tooltip = window.bootstrap?.Tooltip?.getInstance(element);
            if (tooltip && typeof tooltip.dispose === 'function') {
              tooltip.dispose();
            }
            // Remove any tooltip elements that might be stuck in DOM
            const tooltipElements = document.querySelectorAll('.tooltip');
            tooltipElements.forEach(el => {
              if (el && el.parentNode) {
                el.parentNode.removeChild(el);
              }
            });
          } catch (error) {
            // Silently ignore disposal errors
          }
        });
      };

      // Clean up existing tooltips first
      disposeTooltips();

      // Small delay to ensure DOM is ready and previous tooltips are cleaned
      const timeoutId = setTimeout(() => {
        if (window.bootstrap && window.bootstrap.Tooltip && document.querySelector('[data-bs-toggle="tooltip"]')) {
          try {
            const tooltipTriggerList = [].slice.call(
              document.querySelectorAll('[data-bs-toggle="tooltip"]')
            );

            tooltipTriggerList.forEach(tooltipTriggerEl => {
              try {
                // Check if element is still in DOM
                if (document.contains(tooltipTriggerEl)) {
                  // Dispose any existing tooltip on this element first
                  const existingTooltip = window.bootstrap.Tooltip.getInstance(tooltipTriggerEl);
                  if (existingTooltip) {
                    existingTooltip.dispose();
                  }

                  // Create new tooltip
                  new window.bootstrap.Tooltip(tooltipTriggerEl, {
                    trigger: 'hover',
                    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
                    boundary: 'viewport'
                  });
                }
              } catch (error) {
                // Skip this element if there's an error
                console.warn('Failed to initialize tooltip on element:', tooltipTriggerEl, error);
              }
            });
          } catch (error) {
            // Ignore initialization errors
            console.warn('Tooltip initialization failed:', error);
          }
        }
      }, 150);

      // Cleanup function
      return () => {
        clearTimeout(timeoutId);
        disposeTooltips();
      };
    }, [filteredEmailListItems, markReadLoader, markUnreadLoader, addImportantLoader, removeImportantLoader, markTrashLoader]);

    // Additional cleanup on component unmount
    useEffect(() => {
      return () => {
        // Final cleanup when component unmounts
        try {
          const allTooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]');
          allTooltips.forEach(element => {
            try {
              const tooltip = window.bootstrap?.Tooltip?.getInstance(element);
              if (tooltip && typeof tooltip.dispose === 'function') {
                tooltip.dispose();
              }
            } catch (error) {
              // Ignore errors
            }
          });

          // Remove any remaining tooltip elements
          const tooltipElements = document.querySelectorAll('.tooltip');
          tooltipElements.forEach(el => {
            if (el && el.parentNode) {
              el.parentNode.removeChild(el);
            }
          });
        } catch (error) {
          // Ignore cleanup errors
        }
      };
    }, []);

    return (
      <div className="page-content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 main_heading">Fax Inbox</h4>
                <div className="page-title-right">
                  <DefaultView />
                </div>
              </div>
              {/* Left sidebar */}
              <EmailLeftbar />
              {/* End Left sidebar */}

              {/* Right Sidebar */}
              <div className="email-rightbar mb-3">
                <div className="card">
                  <div
                    className="btn-toolbar gap-2 p-3 d-flex justify-content-between"
                    role="toolbar"
                  >
                    <div>
                      <div className="btn-group" style={{ marginRight: 3 }}>
                        <button
                          type="button"
                          className="btn btn-primary waves-light waves-effect dropdown-toggle d-flex"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <div className="checkbox-wrapper-mail">
                            <input type="checkbox" id={`chk_select`} />
                            <label htmlFor={`chk_select`} className="toggle" />
                          </div>{" "}
                          <i className="mdi mdi-chevron-down ms-1" />
                        </button>
                        <div className="dropdown-menu">
                          <div
                            className="dropdown-item"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              handleSelectThisPage("selectThisPage")
                            }
                          >
                            Select This Page
                          </div>
                          <div
                            className="dropdown-item"
                            style={{ cursor: "pointer" }}
                            onClick={handleSelectAll}
                          >
                            Select All
                          </div>
                          <div
                            className="dropdown-item"
                            style={{ cursor: "pointer" }}
                            onClick={handleDeSelectAll}
                          >
                            None
                          </div>
                        </div>
                      </div>
                      <div className="btn-group">
                        {filteredEmailListItems.filter((m) => m.isSelected)
                          .length > 0 && (
                            <>
                              <button
                                onClick={handleMarkReadSelected}
                                data-bs-toggle="tooltip"
                                data-bs-original-title="Mark Read"
                                type="button"
                                className="btn btn-primary waves-light waves-effect"
                              >
                                {markReadLoader ? (
                                  <i
                                    className="fas fa-spinner fa-spin"
                                    data-bs-toggle="tooltip"
                                    data-bs-original-title="Loading"
                                  ></i>
                                ) : (
                                  <i className="fa fa-envelope-open"></i>
                                )}
                              </button>
                              <button
                                onClick={handleMarkUnReadSelected}
                                data-bs-toggle="tooltip"
                                data-bs-original-title="Mark Unread"
                                type="button"
                                className="btn btn-primary waves-light waves-effect"
                              >
                                {markUnreadLoader ? (
                                  <i
                                    className="fas fa-spinner fa-spin"
                                    data-bs-toggle="tooltip"
                                    data-bs-original-title="Loading"
                                  ></i>
                                ) : (
                                  <i className="fa fa-envelope"></i>
                                )}
                              </button>
                              {!listType && (
                                <button
                                  onClick={handleMarkAddImportant}
                                  data-bs-toggle="tooltip"
                                  data-bs-original-title="Mark Important"
                                  type="button"
                                  className="btn btn-primary waves-light waves-effect"
                                >
                                  {addImportantLoader ? (
                                    <i
                                      className="fas fa-spinner fa-spin"
                                      data-bs-toggle="tooltip"
                                      data-bs-original-title="Loading"
                                    ></i>
                                  ) : (
                                    <i className="fa fa-exclamation-circle" />
                                  )}
                                </button>
                              )}
                              <button
                                onClick={handleMarkRemoveImportant}
                                data-bs-toggle="tooltip"
                                data-bs-original-title="Mark Not Important"
                                type="button"
                                className="btn btn-primary waves-light waves-effect"
                              >
                                {removeImportantLoader ? (
                                  <i
                                    className="fas fa-spinner fa-spin"
                                    data-bs-toggle="tooltip"
                                    data-bs-original-title="Loading"
                                  ></i>
                                ) : (
                                  <i className="fa fa-times" />
                                )}
                              </button>
                              {type !== "selectAll" && (
                                <button
                                  onClick={handleMarkTrash}
                                  data-bs-toggle="tooltip"
                                  data-bs-original-title="Move to trash"
                                  type="button"
                                  className="btn btn-primary waves-light waves-effect"
                                >
                                  {markTrashLoader ? (
                                    <i
                                      className="fas fa-spinner fa-spin"
                                      data-bs-toggle="tooltip"
                                      data-bs-original-title="Loading"
                                    ></i>
                                  ) : (
                                    <i className="far fa-trash-alt" />
                                  )}
                                </button>
                              )}
                            </>
                          )}
                      </div>
                      <div
                        className="btn btn-primary"
                        data-bs-toggle="tooltip"
                        data-bs-original-title="Refresh"
                        style={{ cursor: "pointer", marginLeft: 10 }}
                        onClick={() => handleRefresh()}
                      >
                        <i className="fa fa-refresh" aria-hidden="true"></i>
                      </div>

                      {/* <div class="btn-group">
                                        <button type="button" class="btn btn-primary waves-light waves-effect dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i class="fa fa-tag"></i> <i class="mdi mdi-chevron-down ms-1"></i>
                                        </button>
                                        <div class="dropdown-menu">
                                            <Link class="dropdown-item" to="#">Updates</Link>
                                            <Link class="dropdown-item" to="#">Social</Link>
                                            <Link class="dropdown-item" to="#">Team Manage</Link>
                                        </div>
                                    </div>
                                    
                                    <div class="btn-group">
                                        <button type="button" class="btn btn-primary waves-light waves-effect dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                            More <i class="mdi mdi-dots-vertical ms-2"></i>
                                        </button>
                                        <div class="dropdown-menu">
                                            <Link class="dropdown-item" to="#">Mark as Unread</Link>
                                            <Link class="dropdown-item" to="#">Mark as Important</Link>
                                            <Link class="dropdown-item" to="#">Add to Tasks</Link>
                                            <Link class="dropdown-item" to="#">Add Star</Link>
                                            <Link class="dropdown-item" to="#">Mute</Link>
                                        </div>
                                    </div> */}
                    </div>
                    {/* <div class="md-3" style="padding-right:35%;"> </div> */}
                    <div className="d-flex">
                      <div
                        className="btn-group"
                        style={{ marginRight: 10 }}
                        role="group"
                        aria-label="Basic radio toggle button group"
                      >
                        <input
                          type="radio"
                          className="btn-check"
                          name="btnradio"
                          id="btnradio4"
                        />
                        <button
                          onClick={() => {
                            if (pathname !== "/inbox") {
                              offset.current = 0;
                              setSearchText("");
                              setListType("NO");
                              actionGetReceivedMessages(0, "NO");
                              navigate("/inbox");
                            }
                          }}
                          style={{ minWidth: "80px" }}
                          className={`btn ${pathname === "/inbox"
                            ? "btn-primary"
                            : "btn-outline-secondary"
                            }`}
                        >
                          All
                        </button>
                        <input
                          type="radio"
                          className="btn-check"
                          name="btnradio"
                          id="btnradio5"
                          autoComplete="on"
                          defaultChecked=""
                        />
                        <button
                          onClick={() => {
                            if (pathname !== "/inbox/important") {
                              offset.current = 0;
                              setSearchText("");
                              setListType("YES");
                              actionGetReceivedMessages(0, "YES");
                              navigate("/inbox/important");
                            }
                          }}
                          style={{ minWidth: "80px" }}
                          className={`btn ${pathname === "/inbox/important"
                            ? "btn-primary"
                            : "btn-outline-secondary"
                            }`}
                        >
                          Important
                        </button>
                      </div>
                      <form
                        className="app-search d-none d-lg-block"
                        style={{ float: "left" }}
                        onSubmit={(e) => {
                          e.preventDefault();
                          handleSearch();
                        }}
                      >
                        <div className="position-relative">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            value={searchText}
                            onChange={(e) => {
                              setSearchText(e.target.value);
                              if (e.target.value.trim() === "") {
                                actionGetReceivedMessages(
                                  offset.current,
                                  listType
                                );
                              }
                            }}
                          />
                          <button
                            className="btn btn-primary"
                            type="button"
                            onClick={handleSearch}
                          >
                            <i className="bx bx-search-alt align-middle" />
                          </button>
                        </div>
                      </form>
                      <div className="btn-group ms-2">
                        <button
                          type="button"
                          className="btn btn-sm btn-success waves-effect"
                          onClick={handleBackClick}
                          disabled={offset.current === 0}
                        >
                          <i className="fa fa-chevron-left" />
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-success waves-effect"
                          onClick={handleNextClick}
                          disabled={
                            (offset.current + 1) * itemsPerPage >=
                            receivedMessagesCount ||
                            !receivedMessagesCount ||
                            !filteredEmailListItems.length
                          }
                        >
                          <i className="fa fa-chevron-right" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <ul className="message-list faxMessage">
                    {!getReceivedMessagesLoader &&
                      (!filteredEmailListItems ||
                        filteredEmailListItems.length < 1) && (
                        <EmptyResult
                          title={"No Messages Found"}
                          description={"You currently have no messages."}
                        />
                      )}

                    {/* Skeleton loading placeholders similar to FaxCovers.js but table-style */}
                    {getReceivedMessagesLoader && (
                      <>
                        {[...Array(8)].map((_, i) => (
                          <li
                            key={i}
                            className="message-list-item d-flex align-items-center"
                            style={{
                              cursor: "pointer",
                              padding: "12px 16px",
                              borderBottom: "1px solid rgba(0,0,0,0.05)",
                              listStyle: "none",
                              gap: 12,
                            }}
                          >
                            {/* checkbox + star column */}
                            <div
                              style={{
                                width: 60,
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                              }}
                            >
                              <div
                                className="skeleton"
                                style={{
                                  width: 20,
                                  height: 20,
                                  borderRadius: 3,
                                }}
                              />
                              <div
                                className="skeleton"
                                style={{
                                  width: 16,
                                  height: 16,
                                  borderRadius: 2,
                                }}
                              />
                            </div>

                            {/* sender column (name + phone) */}
                            <div style={{ flex: 1, minWidth: 200 }}>
                              <div
                                className="skeleton"
                                style={{ width: "40%", height: 14 }}
                              />
                              <div
                                className="skeleton"
                                style={{
                                  width: "30%",
                                  height: 12,
                                  marginTop: 8,
                                }}
                              />
                            </div>

                            {/* pages column */}
                            <div style={{ width: 120, minWidth: 120 }}>
                              <div
                                className="skeleton"
                                style={{ width: 60, height: 12 }}
                              />
                            </div>

                            {/* date column */}
                            <div
                              style={{
                                width: 160,
                                minWidth: 140,
                                textAlign: "right",
                              }}
                            >
                              <div
                                className="skeleton"
                                style={{
                                  width: 110,
                                  height: 12,
                                  marginLeft: "auto",
                                }}
                              />
                            </div>
                          </li>
                        ))}
                      </>
                    )}

                    {!getReceivedMessagesLoader &&
                      filteredEmailListItems.map((item, index) => (
                        <EmailListItem
                          key={index}
                          index={index}
                          senderName={item.msg.msg_senderName}
                          senderPhone={item.msg.msg_fromNumber}
                          noOfPages={
                            item.msg.msg_totalPages
                              ? item.msg.msg_totalPages
                              : 0
                          }
                          date={item.msg.msg_time}
                          isUnread={parseInt(item.msg.is_read)}
                          isStarred={parseInt(item.msg.is_starred)}
                          isChecked={item.isSelected}
                          handleSelectMessage={handleSelectMessage}
                          handleStarred={handleStarred}
                          detailId={item.msg.recvd_msg_ID}
                          onNavigateToDetail={(detailId) => {
                            navigate(`/read-mail/inbox/${detailId}`, {
                              state: {
                                type: "INBOX",
                                getMessageParams: {
                                  offset: offset.current,
                                  listType,
                                  searchText,
                                },
                              },
                            });
                          }}
                        />
                      ))}
                  </ul>
                </div>{" "}
                {/* card */}
                <div className="row">
                  <div className="col-7">
                    Showing {receivedMessagesCount > 0 ? showingFrom : 0} -{" "}
                    {receivedMessagesCount > 0 ? showingTo : 0} of{" "}
                    {receivedMessagesCount ? receivedMessagesCount : 0}
                  </div>
                  <div className="col-5">
                    <BackAndNextButtonsGroup />
                  </div>
                </div>
              </div>
              {/* end  Right Sidebar Col-9 */}
            </div>
          </div>
        </div>
      </div>
    );
  }
);

const mapStateToProps = (state) => {
  return {
    getReceivedMessagesLoader: state.inbox.getReceivedMessagesLoader,
    receivedMessages: state.inbox.receivedMessages,
    receivedMessagesCount: state.inbox.receivedMessagesCount,
    addImportantLoader: state.inbox.addImportantLoader,
    removeImportantLoader: state.inbox.removeImportantLoader,
    markReadLoader: state.inbox.markReadLoader,
    markUnreadLoader: state.inbox.markUnreadLoader,
    markTrashLoader: state.inbox.markTrashLoader,
  };
};

export default connect(mapStateToProps, {
  actionGetReceivedMessages,
  actionMarkAddImportant,
  actionMarkRemoveImportant,
  actionMarkReadMessages,
  actionMarkUnreadMessages,
  actionMarkAddStarred,
  actionMarkRemoveStarred,
  actionMarkTrashMessage,
  actionGetUnReadMessagesCount
})(Inbox);
